import { ThemeOptions, createTheme } from "@mui/material/styles";
const themeOptions:ThemeOptions = {
    palette: {
      primary: {
        main: "#ff6633",
      }
    }
  }
  
  export const theme = createTheme(themeOptions);